"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right5"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _Details = _interopRequireDefault(require("./Details"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Appdefs = window.cccisd.appDefs;
var ByGrade = function ByGrade(_ref) {
  var byGrade = _ref.byGrade,
    studentLabel = _ref.studentLabel;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var gradeLabelMapper = {};
  try {
    Appdefs.pawn.fields.find(function (f) {
      return f.handle === 'grade';
    }).values.forEach(function (grade) {
      gradeLabelMapper[grade.value] = grade.name;
    });
  } catch (e) {
    // meh *shrug*
  }
  if (!isExpanded) {
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: 'btn btn-xs btn-link ' + _style["default"].toggleGradeDetails,
      type: "button",
      onClick: function onClick() {
        return setIsExpanded(true);
      }
    }, "Show ", studentLabel, " by grade\xA0", /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], null));
  }
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    className: 'btn btn-xs btn-link ' + _style["default"].toggleGradeDetails,
    type: "button",
    onClick: function onClick() {
      return setIsExpanded(false);
    }
  }, "Hide ", studentLabel, " by grade\xA0", /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("ul", {
    className: _style["default"].byGradeList
  }, Object.keys(byGrade).sort(function (a, b) {
    var intA = parseInt(a, 10);
    var intB = parseInt(b, 10);
    if (!Number.isNaN(intA) && !Number.isNaN(intB)) {
      return intA - intB;
    }
    if (!Number.isNaN(intA) && Number.isNaN(intB)) {
      return -1;
    }
    if (Number.isNaN(intA) && !Number.isNaN(intB)) {
      return 1;
    }
    return a > b ? 1 : -1;
  }).map(function (grade) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: grade
    }, /*#__PURE__*/_react["default"].createElement("b", null, gradeLabelMapper[grade], ":"), "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_Details["default"], {
      countObject: byGrade[grade]
    }));
  })));
};
var _default = exports["default"] = ByGrade;